import {
  RtFraction,
  RtWithName,
  RtWithProjectionPeriods,
  RtWithRelativesSet,
} from "@aprao/common/src/runtypes/common.js";
import { z } from "zod";

import { WithTimelineOverrideSchema } from "./TimelineStageSchema.js";
export const RtLoanType = z.enum(["interest", "profitShare"]);
export const RtInterestFormulation = z.enum(["drawnBalance", "fullAmount"]);
export const RtInterestCalculationType = z.enum(["auto", "manual", "cashflow"]);
export const RtInterestRatePeriod = z.enum(["year", "month"]);

export const RtInterestPayoutType = z.enum([
  "serviced",
  "rolledUp",
  "retained",
]);

export const RtFacilitySizeKeys = z.enum([
  "absolute",
  "ratioDebtFundedDevCost",
  "ratioDebtFundedGdv",
]);

export const RtLenderFeeKeys = z.enum([
  "absolute",
  "ratioFacilitySize",
  "ratioDebtFundedGdv",
]);

export const RtLenderFeePaymentSchedule = z.enum(["commitment", "exit"]);

export const RtLenderFee = RtWithRelativesSet(RtLenderFeeKeys)
  .merge(RtWithName)
  .merge(RtWithProjectionPeriods)
  .merge(WithTimelineOverrideSchema)
  .extend({
    paymentSchedule: RtLenderFeePaymentSchedule,
  });

export const RtInterestRate = z.strictObject({
  rateMargin: RtFraction.nullable(),
  ratePeriod: RtInterestRatePeriod,
});

export const RtInterest = z.strictObject({
  formulation: RtInterestFormulation,
  calculationType: RtInterestCalculationType,
  rate: RtInterestRate,
  definedAmount: RtFraction.nullable(),
  payoutType: RtInterestPayoutType,
  /**
   * Only makes sense for retained payout type and when the allowance calculation
   * type is set to `manual`.
   */
  definedAllowance: RtFraction.nullable(),
});

export const RtLenderBase = z.strictObject({
  name: z.string(),
  facilitySize: RtWithRelativesSet(RtFacilitySizeKeys),
  fees: z.array(RtLenderFee),
});

export const RtInterestLender = RtLenderBase.extend({
  loanType: z.literal("interest"),
  definedTermInMonths: z.number().nullable(),
  interest: RtInterest,
});

export const RtProfitShareLender = RtLenderBase.extend({
  loanType: z.literal("profitShare"),
  profitShare: RtFraction.nullable(),
});
